// Unpublished Work © 2023-2024 Deere & Company.

import { Box } from "@mui/material";
import NoResultsTableFilter from "../../../../components/Table/components/NoResultsTableFilter/NoResultsTableFilter";

const InvoiceLineItemsNoResultsOverlay = ({
  searchTerm,
  updateSearchTerm,
}: {
  searchTerm: string;
  updateSearchTerm: (newSearchTerm: string) => void;
}) => (
  <Box
    sx={{
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <NoResultsTableFilter
        searchTerm={searchTerm}
        clearSearch={() => updateSearchTerm("")}
      />
    </Box>
  </Box>
);

export default InvoiceLineItemsNoResultsOverlay;
